import { ModuleHeader, SettingsIcon, Text } from '@viapeople/components'
import { useNavigate } from 'react-router-dom'

interface SettingsMenuItem {
	id: string
	title: string
	description: string
	href: string
	icon: React.ReactNode
}

export const GlobalSettingsPage = () => {
	const navigate = useNavigate()

	const menuItems: SettingsMenuItem[] = [
		{
			id: 'maintenance-mode',
			title: 'Maintenance Mode',
			description: 'Enable or disable maintenance mode for organizations to temporarily block client access.',
			href: '/settings/maintenance-mode',
			icon: <SettingsIcon size={24} className='text-primary-600' />,
		},
	]

	return (
		<main className='w-full p-6 flex flex-col gap-6'>
			<ModuleHeader breadcrumb={[{ label: 'Global Settings' }]} title='Global Settings' />

			<Text variant='small' className='text-neutral-600 -mt-4'>
				Configure system-wide settings that apply across all organizations.
			</Text>

			<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
				{menuItems.map((item) => (
					<button
						type='button'
						key={item.id}
						onClick={() => navigate(item.href)}
						className='p-6 bg-white border border-neutral-200 rounded-lg hover:border-primary-500 hover:shadow-md transition-all text-left flex flex-col gap-3'>
						<div className='flex items-center gap-3'>
							{item.icon}
							<Text variant='medium' weight='semibold'>
								{item.title}
							</Text>
						</div>
						<Text variant='small' className='text-neutral-600'>
							{item.description}
						</Text>
					</button>
				))}
			</div>
		</main>
	)
}
